import { cn } from "@bidbattles/bloks/lib/ui";
import type { RegisteredRouter } from "@tanstack/react-router";
import { Link, type LinkProps } from "./link";

const baseClassNames = cn(
	"focus-visible:outline-offset-4 inline-flex justify-center items-center gap-2 cursor-pointer disabled:cursor-not-allowed outline-transparent",
);

const variantClassNames = {
	default: cn(
		"appearance-none text-white font-medium bg-gradient-to-r from-btn-bg-from to-btn-bg-to",
		"rounded-btn shadow-btn active:shadow-btn-pressed focus-visible:outline-accent-primary",
		"disabled:opacity-70",
		"duration-150 ease-in-out",
	),
	outline: cn(
		"border rounded-btn border-gray-300 text-gray-700 disabled:text-gray-500 disabled:border-gray-200",
		"active:bg-gray-200 focus-visible:outline-gray-400",
		"duration-150 ease-in-out",
	),
	white: cn(
		"border rounded-btn bg-white border-gray-300 text-gray-700 disabled:text-gray-500 disabled:border-gray-200",
		"active:bg-gray-200 focus-visible:outline-gray-400",
		"duration-150 ease-in-out",
	),
	crmGrey: cn(
		"border rounded-btn bg-crm-button-grey border-crm-button-grey-border text-white disabled:text-gray-700",
		"active:bg-gray-900 focus-visible:outline-gray-400 font-semibold",
		"duration-150 ease-in-out",
	),
	solid: cn("border rounded-btn duration-150 ease-in-out"),
	link: cn(
		"text-accent-primary disabled:opacity-80 p-0 focus-visible:outline-accent-primary",
	),
	icon: cn("rounded-full focus-visible:outline-accent-primary"),
	unstyled: "p-0",
};
type ButtonVariant = keyof typeof variantClassNames;

const sizeClassNames = {
	sm: cn("py-2 px-3.5 text-xs lg:text-sm gap-2"),
	lg: cn("py-3 px-5"),
	icon: cn("size-9"),
	"icon-sm": cn("size-4"),
	content: "",
};
type ButtonSize = keyof typeof sizeClassNames;

export type ButtonVariantProps = { variant?: ButtonVariant; size?: ButtonSize };

export function Button({
	className,
	type,
	variant = "default",
	size = "lg",
	...props
}: React.ComponentProps<"button"> & ButtonVariantProps) {
	return (
		<button
			type={type ?? "button"}
			className={cn(
				sizeClassNames[size],
				baseClassNames,
				variantClassNames[variant],
				className,
			)}
			{...props}
		/>
	);
}

export function ButtonLink<
	TRouter extends RegisteredRouter = RegisteredRouter,
	TOptions = unknown,
>({
	variant = "default",
	size = "lg",
	...props
}: LinkProps<TRouter, TOptions> & ButtonVariantProps) {
	return (
		// TODO: Fucking types.
		// @ts-expect-error
		<Link
			{...props}
			className={cn(
				baseClassNames,
				sizeClassNames[size],
				variantClassNames[variant],
				props.className,
			)}
		/>
	);
}
